import React from 'react';
import './MortgageTypes.css';

interface MortgageTypeCard {
  icon: string;
  title: string;
  description: string;
  bestFor: string[];
  cta: string;
}

interface MortgageTypesProps {
  headline: string;
  description: string;
  cards: MortgageTypeCard[];
}

const MortgageTypes: React.FC<MortgageTypesProps> = ({ headline, description, cards }) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="mortgage-types">
      <div className="mortgage-types-container">
        <div className="mortgage-types-header">
          <h2 className="mortgage-types-headline">
            {headline}
          </h2>
          <p className="mortgage-types-description">
            {description}
          </p>
        </div>
        
        <div className="mortgage-types-grid">
          {cards.map((card, index) => (
            <div key={index} className="mortgage-type-card">
              <div className="card-icon">
                {card.icon}
              </div>
              <h3 className="card-title">
                {card.title}
              </h3>
              <p className="card-description">
                {card.description}
              </p>
              
              <div className="card-best-for">
                <div className="best-for-header">
                  <span className="checkmark">✓</span>
                  <span className="best-for-label">Best For</span>
                </div>
                <ul className="best-for-list">
                  {card.bestFor.map((item, itemIndex) => (
                    <li key={itemIndex} className="best-for-item">
                      <span className="star">★</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              
              <button 
                className="card-cta"
                onClick={() => scrollToSection('contact')}
              >
                {card.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MortgageTypes;